const noop = () => {};

const logger = import.meta.env.DEV
    ? {
          log: (...args) => console.log(...args),
          warn: (...args) => console.warn(...args),
          error: (...args) => console.error(...args),
      }
    : { log: noop, warn: noop, error: noop };

export default logger;
